/**
 * 环境趋势 store
 */

import axios from "../../utils/axios";

let state = {
  sensorData: []
};

let getters = {

};

let mutations = {
  setEnvChartMessage(state, payload) {
    state.sensorData = payload.sensorData
  }
};

let actions = {
  envChartMessage({commit}, payload) {
    return new Promise((resolve, reject) => {
      axios.get(`/sensor?room_id=${payload.id}`)
      .then(res => {
        if (res.status === 200) {
          commit("setEnvChartMessage", {
            sensorData: res.data.data
          });
          resolve(res.data.data);
        }
      })
      .catch(error => {
        console.error(error);
        reject();
      });
    });
  }
};

export default {
  state,
  getters,
  mutations,
  actions
}